import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Cart, CartService, Declination, DeclinationService, Product, ProductService, Shipping, Variation, VariationService } from 'octali-lib-shop';
import { DisplayerService } from 'octali-lib-utils';
import { combineLatest } from 'rxjs';
import { ShippingCartDetailViewComponent } from 'src/app/components/shipping/shipping-cart-detail-view/shipping-cart-detail-view.component';
import { PaiementPage } from '../paiement/paiement.page';
import { LoginPage } from '../user/login/login.page';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {

  @ViewChild('cartDetails', { read: ShippingCartDetailViewComponent, static: false }) cartDetails: ShippingCartDetailViewComponent;
  
  public cart:Cart;
  public declinationsId: Map<string,Declination>;
  public productsId: Map<string, Product>;
  public variationsId: Map<string,Variation>;
  public total:number = 0;
  public shippingSelected : Shipping;
  private shippingCost: number = 0;
  
  public paidByCard:boolean = true;
  public paidByCheque: boolean = true;

  constructor(
    private cartService: CartService,
    private productService: ProductService,
    private declinationService: DeclinationService,
    private variationService: VariationService,
    private displayer: DisplayerService,
    private navCtrl: NavController
  ) { 
    combineLatest( [
      this.productService.getProductsByIdObs(),
      this.declinationService.getDeclinationsByIdObs(),
      this.variationService.getVariationsIdObs(),
      this.cartService.getCartObs()
    ])
    .subscribe( async ([productsId, declinationsId, variationsId, cart]) => {
      if(productsId && declinationsId && variationsId && cart){
        this.productsId =productsId;
        this.declinationsId = declinationsId;
        this.variationsId = variationsId;
        console.log( cart );
        if ( cart )  {
          this.total = 0;
          this.cart = cart;
          for(let product of cart.products){
            this.total = this.total + (Number(this.productsId.get(product[0]).wprice)*product[1]);
            if(this.productsId.get(product[0]).quantity < product[1]){
              await this.cartService.addProduct(this.productsId.get(product[0]),Number(this.productsId.get(product[0]).quantity-product[1]),false);
              await this.displayer.presentAlert("Info panier","Mise à jour","Certain produit de votre panier sont en quantité insuffisante dans notre stock. Nous avons mis à jour les quantités en conséquence.");
            }
          }
          for(let variation of cart.variations){
            console.log(this.declinationsId.get(variation[0]));
            this.total = this.total + (Number(this.declinationsId.get(variation[0]).wprice)*variation[1]);
            if(this.declinationsId.get(variation[0]).quantity < variation[1]){
              await this.cartService.addDeclination(this.declinationsId.get(variation[0]),Number(this.declinationsId.get(variation[0]).quantity-variation[1]),false);
              await this.displayer.presentAlert("Info panier","Mise à jour","Certain produit de votre panier sont en quantité insuffisante dans notre stock. Nous avons mis à jour les quantités en conséquence.");
            }
              
          }
        }
      }
      
    });

  }

  ngOnInit() {
  }


  async removeProduct( pProduct ) {
    await this.cartService.addProduct(this.productsId.get( pProduct ), -1);
  }

  async addProduct( pProduct ) {
    await this.cartService.addProduct(this.productsId.get( pProduct ), 1);
  }

  async removeDeclination( pDeclination ) {
    await this.cartService.addDeclination(this.declinationsId.get( pDeclination ), -1);
  }

  async addDeclination( pDeclination ) {
    await this.cartService.addDeclination(this.declinationsId.get( pDeclination ), 1);
  }

  async delDeclination( pDeclination ) {
    await this.cartService.removeItemDeclination( pDeclination );
  }

  async delProduct( pProduct ) {
    await this.cartService.removeItemProduct( pProduct );
  }

  calculatePrice(price,quantity){
    return (price*quantity).toFixed(2);
  }

  getTitle(declination:Declination) :string{
    let vars :string="";
    if(declination)
      for(let i of declination.values){
        vars += this.variationsId.get(i[0]).nameValue+" "+i[1];
    }
    let product = this.productsId.get(declination.product);
    if( product)
      return product.title + " " + vars;
  }

  async login() {
    console.log("login");
    await this.displayer.presentModal( LoginPage );
  }
  setAddress() {
    console.log("setAddress");
    this.navCtrl.navigateRoot('mon-adresse');
  }

  selectShipping( shipping ){
    this.shippingSelected = shipping;
    console.log("selectShipping");
  }

  setShippingCost( cost: number){
    this.shippingCost = cost;
  }

  getTotal(){
    if(this.shippingSelected && this.cartDetails.getPrice(this.shippingSelected) != 'offert')
      return this.total + this.shippingCost;
    else
      return this.total;
  }

  paid( byCheque: boolean) {
    this.displayer.presentModal(PaiementPage,{total:this.getTotal(),paidByCheque:byCheque, shipping:this.shippingSelected, shippingPrice:this.shippingCost});
  }

  paidCheque() {

  }
}
